
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("bC6IV", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $8748757b4d3e08dd$export$dd0a697e1782aedd; });

var $1rwT3 = parcelRequire("1rwT3");

var $i6rVm = parcelRequire("i6rVm");

var $aX1RZ = parcelRequire("aX1RZ");

var $4uBuq = parcelRequire("4uBuq");

var $7pBLZ = parcelRequire("7pBLZ");

var $k8Y7p = parcelRequire("k8Y7p");
var $jHaP3 = parcelRequire("jHaP3");
var $k6dP7 = parcelRequire("k6dP7");
var $1d8pV = parcelRequire("1d8pV");
var $ggJzq = parcelRequire("ggJzq");

var $4IsRY = parcelRequire("4IsRY");

var $kBJCe = parcelRequire("kBJCe");

var $5eStZ = parcelRequire("5eStZ");

var $kNNtr = parcelRequire("kNNtr");

var $f2V1P = parcelRequire("f2V1P");
var $8748757b4d3e08dd$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8748757b4d3e08dd$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return $8748757b4d3e08dd$export$6342ea8c555e49e5((0, $f2V1P.useApolloClient)(options.client), query).useQuery(options);
}
function $8748757b4d3e08dd$export$6342ea8c555e49e5(client, query) {
    var stateRef = $aX1RZ.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $8748757b4d3e08dd$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    state.forceUpdateState = $aX1RZ.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var $8748757b4d3e08dd$var$InternalState = function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, $1d8pV.maybeDeepFreeze)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $5eStZ.NetworkStatus).loading
        });
        this.skipStandbyResult = (0, $1d8pV.maybeDeepFreeze)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $5eStZ.NetworkStatus).ready
        });
        this.toQueryResultCache = new ((0, $k8Y7p.canUseWeakMap) ? WeakMap : Map)();
        (0, $kNNtr.verifyDocumentType)(query, (0, $kNNtr.DocumentType).Query);
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    InternalState.prototype.forceUpdateState = function() {
        globalThis.__DEV__ !== false && (0, $i6rVm.invariant).warn(48);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        this.renderPromises = $aX1RZ.useContext((0, $4IsRY.getApolloContext)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $4uBuq.useSyncExternalStore)($aX1RZ.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                var result = obsQuery.getCurrentResult();
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $7pBLZ.equal)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!$8748757b4d3e08dd$var$hasOwnProperty.call(error, "graphQLErrors")) throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $7pBLZ.equal)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $5eStZ.NetworkStatus).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, $7pBLZ.equal)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                this.observable.reobserve(this.getObsQueryOptions());
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        toMerge.push((0, $jHaP3.compact)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $ggJzq.mergeOptions));
    };
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, otherOptions = (0, $1rwT3.__rest)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = $aX1RZ.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, $5eStZ.NetworkStatus).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, $i6rVm.invariant).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, $k6dP7.isNonEmptyArray)(result.errors) ? new (0, $kBJCe.ApolloError)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $1rwT3.__rest)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $1rwT3.__assign)((0, $1rwT3.__assign)((0, $1rwT3.__assign)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $k6dP7.isNonEmptyArray)(result.errors)) queryResult.error = new (0, $kBJCe.ApolloError)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $5eStZ.NetworkStatus).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();

});
parcelRegister("4uBuq", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $34570b758e641110$export$306c0aa65ff9ec16; });

var $i6rVm = parcelRequire("i6rVm");

var $aX1RZ = parcelRequire("aX1RZ");

var $k8Y7p = parcelRequire("k8Y7p");
var $34570b758e641110$var$didWarnUncachedGetSnapshot = false;
var $34570b758e641110$var$uSESKey = "useSyncExternalStore";
var $34570b758e641110$var$realHook = $aX1RZ[$34570b758e641110$var$uSESKey];
var $34570b758e641110$export$306c0aa65ff9ec16 = $34570b758e641110$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    var value = getSnapshot();
    if (globalThis.__DEV__ !== false && !$34570b758e641110$var$didWarnUncachedGetSnapshot && value !== getSnapshot()) {
        $34570b758e641110$var$didWarnUncachedGetSnapshot = true;
        globalThis.__DEV__ !== false && (0, $i6rVm.invariant).error(56);
    }
    var _a = $aX1RZ.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    if (0, $k8Y7p.canUseLayoutEffect) $aX1RZ.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        if ($34570b758e641110$var$checkIfSnapshotChanged(inst)) forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $aX1RZ.useEffect(function() {
        if ($34570b758e641110$var$checkIfSnapshotChanged(inst)) forceUpdate({
            inst: inst
        });
        return subscribe(function handleStoreChange() {
            if ($34570b758e641110$var$checkIfSnapshotChanged(inst)) forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $34570b758e641110$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}

});



//# sourceMappingURL=Homepage.1d4dfe12.js.map
